import { Button, Stack } from '@montugroup/design-system';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import { useState } from 'react';
import { DeletePrescriptionModal } from './DeletePrescriptionModal';
import { SharePrescriptionModal } from './SharePrescriptionModal';

interface PrescriptionActionsProps {
  prescriptionId: number;
  canDelete: boolean;
}

export function PrescriptionActions({ prescriptionId, canDelete = false }: PrescriptionActionsProps) {
  const [isDeletePrescriptionModalOpen, setIsDeletePrescriptionModalOpen] = useState(false);
  const [isSharePrescriptionModalOpen, setIsSharePrescriptionModalOpen] = useState(false);

  return (
    <Stack direction={'row'} gap={4}>
      <Button
        startIcon={<ShareIcon />}
        variant="contained"
        size="large"
        fullWidth
        onClick={() => setIsSharePrescriptionModalOpen(true)}
      >
        Share
      </Button>
      <Button
        disabled={!canDelete}
        startIcon={<DeleteIcon />}
        variant="contained"
        color="error"
        size="large"
        fullWidth
        onClick={() => setIsDeletePrescriptionModalOpen(true)}
      >
        Delete
      </Button>
      <SharePrescriptionModal
        open={isSharePrescriptionModalOpen}
        onClose={() => setIsSharePrescriptionModalOpen(false)}
        prescriptionId={prescriptionId}
      />
      <DeletePrescriptionModal
        open={isDeletePrescriptionModalOpen}
        onClose={() => setIsDeletePrescriptionModalOpen(false)}
        prescriptionId={prescriptionId}
      />
    </Stack>
  );
}
